export const logoSrcSetGenerator = (src1: string, src2: string): string => {
  return `${src1}, ${src2} 2x`;
};
